type OppSyncOnboardingReader = (isCosellEnabled?: boolean) => {
  onboardingComplete: boolean
  isNewPartner: boolean
}

let registeredOppSyncOnboardingStatus: OppSyncOnboardingReader | undefined

export const registerOppSyncOnboardingStatus = (
  reader: OppSyncOnboardingReader
) => {
  registeredOppSyncOnboardingStatus = reader
}

export const useRegisteredOppSyncOnboardingStatus: OppSyncOnboardingReader = (
  isCosellEnabled = false
) => {
  if (!registeredOppSyncOnboardingStatus) {
    throw new Error(
      'registerOppSyncOnboardingStatus must run before useAnyOneOnboardingCompeted'
    )
  }
  return registeredOppSyncOnboardingStatus(isCosellEnabled)
}
